export const rustWebAppProcessData = [
  {
    step: '1',
    title: `Discovery & Architecture Design`,
    description: `We start by understanding your performance requirements, scalability goals, and existing infrastructure. Then we design an architecture that plays to Rust's strengths while integrating seamlessly with your current systems.`,
  },
  {
    step: '2',
    title: `Iterative Development`,
    description: `We build in sprints, delivering working features every 1-2 weeks. You see progress continuously and can provide feedback early. No surprises at the end.`,
  },
  {
    step: '3',
    title: `Performance Optimization`,
    description: `Rust is fast by default, but we go further. We profile your application under realistic load, identify bottlenecks, and optimize hot paths. Our goal is to maximize your infrastructure ROI.`,
  },
  {
    step: '4',
    title: 'Testing & Documentation',
    description: `Every feature comes with comprehensive tests (unit, integration, load). We document both the code and the system architecture, so your team can maintain and extend the application confidently.`,
  },
  {
    step: '5',
    title: `Deployment & Monitoring`,
    description: `We containerize your application with Docker, set up CI/CD pipelines, and implement monitoring with metrics, logging, and tracing. You get full visibility into your system's behavior.`,
  },
  {
    step: '6',
    title: `Knowledge Transfer`,
    description: `Your team gets the knowledge they need. We provide documentation, code walkthroughs, and hands-on training so they can confidently work with the Rust codebase.`,
  },
];
